// Liga o núcleo do produto ao DOM da PDP: selo de encaixe e "serve nestes modelos".
// O produto vem do HTML (data-*), o veículo vem da garagem do B1. Repinta no evento core.EVENTO
// (arpine:veiculo-alterado), sem recarregar. Nome de veículo SEMPRE por textContent.
const produto = await window.ArpineDS.importar("produto");
const core = await window.ArpineDS.importar("core");
const { garagem } = await window.ArpineDS.importar("garagem");

const fit = document.querySelector("[data-ds-fit]");
const CHAVE_TEXTO = { serve: "textoServe", ano: "textoAno", outro: "textoOutro" };

function preencher(modelo, dados) {
  return modelo
    .replace(/\{veiculo\}/g, dados.veiculo)
    .replace(/\{peca\}/g, dados.peca)
    .replace(/\{anos\}/g, dados.anos);
}

function pintarEncaixe() {
  if (!fit) return;
  const peca = {
    marca: fit.dataset.marca,
    modelo: fit.dataset.modelo,
    anos: (fit.dataset.anos || "").split(",").map((a) => a.trim()).filter(Boolean),
  };
  // garagem.ativo() em vez de reimplementar a busca (g.veiculos.find(v => v.id === g.ativo)) —
  // mesma função que os outros consumidores do B1 usam.
  const ativo = garagem.ativo();
  const estado = produto.estadoEncaixe(peca, ativo);
  const alvo = fit.querySelector("[data-ds-fit-texto]");
  const link = fit.querySelector("[data-ds-fit-link]");

  if (!estado) {
    fit.hidden = true;
    delete fit.dataset.estado;
    return;
  }

  // Cópia ordenada numericamente: o metacampo normalmente já vem ordenado do pipeline, mas nada no
  // admin impede uma edição manual fora de ordem, e aí a faixa mostraria "2019-2013".
  const anosOrdenados = [...peca.anos].sort((a, b) => Number(a) - Number(b));
  const anos = anosOrdenados.length ? `${anosOrdenados[0]}-${anosOrdenados[anosOrdenados.length - 1]}` : "";
  const dados = {
    veiculo: [ativo.marca, ativo.modelo, ativo.ano].filter(Boolean).join(" "),
    peca: [peca.marca, peca.modelo].filter(Boolean).join(" "),
    anos,
  };
  alvo.textContent = preencher(fit.dataset[CHAVE_TEXTO[estado]], dados);
  fit.dataset.estado = estado;
  fit.hidden = false;

  const mostrarLink = estado !== "serve";
  link.hidden = !mostrarLink;
  if (mostrarLink) {
    link.textContent = fit.dataset.textoLink;
    const u = new URL(fit.dataset.urlVeiculo, location.origin);
    u.searchParams.set("marca", ativo.marca);
    u.searchParams.set("modelo", ativo.modelo);
    if (ativo.ano) u.searchParams.set("ano", ativo.ano);
    link.href = u.pathname + u.search;
  }
}

function recolherCompat() {
  const caixa = document.querySelector("[data-ds-compat]");
  if (!caixa) return;
  const corpo = caixa.querySelector("[data-ds-compat-corpo]");
  const botao = caixa.querySelector("[data-ds-compat-mais]");
  corpo.dataset.recolhido = "";

  // A 1a medida (requestAnimationFrame, layout já pronto) pode sair da fonte de fallback: com
  // font-display: swap a fonte do tema troca depois, e o texto que só estoura com ela pode ficar
  // com "ver todos" escondido pra sempre. document.fonts.ready mede de novo quando a fonte troca.
  // Mesma função pros dois gatilhos (sem duplicar lógica); só remede se ninguém já abriu o texto
  // (não some com o "ver todos" nem re-trunca o que a pessoa já expandiu).
  function medir() {
    if (!("recolhido" in corpo.dataset)) return;
    const cortado = corpo.scrollHeight > corpo.clientHeight + 2;
    botao.hidden = !cortado;
    if (!cortado) delete corpo.dataset.recolhido;
  }
  requestAnimationFrame(medir);
  document.fonts?.ready?.then(medir);

  botao.addEventListener("click", () => {
    delete corpo.dataset.recolhido;
    botao.hidden = true;
  });
}

pintarEncaixe();
recolherCompat();
document.addEventListener(core.EVENTO, pintarEncaixe);
